<template>
  <div>
    <NavBtns></NavBtns>
    <section id="faq1">
      <div class="container-fluid">
        <div class="row">
          <!--黑板-->
          <div class="col-xl-9 col-sm-12 order-xl-2 order-md-1">
            <div class="whitebox">
              <div class="qtext">
                Q：
                <div class="text1">{{ current_q[$i18n.locale] }}</div>
              </div>
              <div class="atext">
                A：
                <div class="text1" v-html="current_a[$i18n.locale]"></div>
              </div>
            </div>
          </div>
          <div class="col-xl-offset-1"></div>
          <div class="col-xl-3 col-sm-12 order-xl-1 order-md-2">
            <!--提問鈕-->
            <div class="blackbox" @click="vShowSendQuestionWin()">
              <div class="text">{{ $t('message.fq_question') }}</div>
            </div>
            <!--問題 tag-->
            <div class="libox">
              <ul>
                <li
                  v-for="(tag, index) in tags"
                  :class="{ active: tag.is_current }"
                  v-bind:key="index"
                >
                  <a href="#" @click.prevent="vFilterFaq(index)">{{
                    tag[$i18n.locale]
                  }}</a>
                </li>
              </ul>
              <!--問題集-->
              <div class="bbox">
                <div
                  class="button"
                  v-for="(faq, faq_idx) in filter_faq"
                  @click="vShowFullFaqContent(faq)"
                  v-bind:key="faq_idx"
                >
                  {{ faq['question_i18n'][$i18n.locale] }}
                  <p>
                    {{
                      faq['tag_i18n']
                        .map(function (elem) {
                          return elem[$i18n.locale];
                        })
                        .join('、')
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--提問視窗-->
      <div class="qaopenbox" :class="{ show: show_question_win }">
        <div class="bgbox" @click="vCloseSendQuestionWin()"></div>
        <div class="whitebox2" :class="{ show: !is_lock_send }">
          <div v-if="!is_offline" class="title">
            {{ $t('message.fq_question') }}
            <div class="orangetext">
              {{ $t('message.fq_thx_asking') }}
              <p>{{ $t('message.fq_thx_content') }}</p>
            </div>
            <form id="recaptcha-form">
              <div class="emailbox">
                <label>E-mail </label>
                <input
                  v-model="question_asker"
                  class="signoff"
                  name="email"
                  :placeholder="$t('message.fq_email')"
                />
              </div>
              <div class="areabox" :class="{ red: question_stress_textarea }">
                <textarea
                  v-model="question_content"
                  name="content"
                  :placeholder="$t('message.fq_char_limit', { limit: 300 })"
                  :maxlength="300"
                  rows="7"
                >
                </textarea>
              </div>
              <div class="error" :class="{ show: question_error }">
                <div class="box">
                  <i class="fas fa-times-circle"></i>
                  <div class="redtext">
                    {{ $t('message.' + question_error_label) }}
                  </div>
                </div>
              </div>
              <div :class="['button']" @click="vSendQuestion()">
                {{ $t('message.fq_send') }}
              </div>
              <div class="robotbox">
                <div
                  class="text"
                  v-html="$t('message.fq_recaptcha_declare')"
                ></div>
              </div>
            </form>
          </div>
          <!--離線提示-->
          <div class="offlinebox" :class="{ show: is_offline }">
            <div class="offallbox">
              <div class="imgbox">
                <img
                  class="img-fluid"
                  src="../assets/images/offline.svg"
                  alt="offline"
                />
              </div>
              <div class="text">{{ $t('message.pb_offline') }}</div>
            </div>
          </div>
          <div class="lineall" @click="vCloseSendQuestionWin()">
            <div class="line1"></div>
            <div class="line2"></div>
          </div>
        </div>
        <div :class="['loadingbox', { show: is_lock_send }]">
          <div class="owlanibox"></div>
          <div :class="['loadtext']" v-if="!replySuccess">
            <span>{{ $t('message.fq_sending') }}</span>
            <div class="circle1"></div>
            <div class="circle2"></div>
            <div class="circle3"></div>
          </div>
          <div v-else :class="['loadtext']">
            {{ $t('message.fq_send_success') }}
            <i
              class="fas fa-check animated bounceIn"
              style="color: #ff6c00"
            ></i>
          </div>
        </div>
      </div>
    </section>

    <!--貓頭鷹-->
    <section id="owl_ani">
      <img class="owl" id="owl" src="/img/faq/owl_left_top.svg" />
      <!--提問鈕-->
      <div class="blackbox" @click="vShowSendQuestionWin()">
        <div class="text">{{ $t('message.fq_question') }}</div>
      </div>
    </section>

    <!--頁尾-->
    <GzFooter></GzFooter>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import $ from 'jquery';

// @ is an alias to /src
import NavBtns from '@/components/NavBtns.vue';
import GzFooter from '@/components/GzFooter.vue';
import Public from '@/scripts/public';

export default {
  name: 'Faq',
  components: {
    NavBtns,
    GzFooter,
  },
  data: function () {
    return {
      faq_api: Public.appGetAPIURL('faq'),
      send_faq_api: Public.appGetAPIURL('send-faq'),
      //問題 tag 分類
      tags: [
        {
          'zh-TW': '全部',
          'en-US': 'All',
          is_current: true,
        },
      ],
      //問題集(全)
      origin_faq: [],
      //問題集(依tag過濾後)
      filter_faq: [],
      //黑板問題
      current_q: {
        'zh-TW': '',
        'en-US': '',
      },
      //黑板答案
      current_a: {
        'zh-TW': '',
        'en-US': '',
      },
      //顯示提問視窗
      show_question_win: false,
      //提問者 email
      question_asker: '',
      //提問問題內容
      question_content: '',
      //是否強調提問視窗內 textarea 區域
      question_stress_textarea: false,
      //提問視窗內錯誤訊息顯示
      question_error: false,
      //提問視窗內錯誤訊息顯示內容 (i18n label)
      question_error_label: 'fq_no_content',
      // 鎖定傳送鈕
      is_lock_send: false,
      // 回傳成功畫面控制
      replySuccess: false,
      //google - reCAPTCHA
      site_key: '6LdEbOQUAAAAAJiWtSpacUcY7rwuhuCGO37QgSs8', //localhost 測試的 site_key : 6LfnZecUAAAAAKMXRVl_GtDDvuHfr6RiJznbDDS-
    };
  },
  computed: {
    //網路連線狀態
    is_offline: function () {
      return this.net_offline;
    },
    ...mapState({
      net_offline: (state) => state.is_offline,
    }),
  },
  beforeDestroy: function () {
    $(window).unbind('mousemove');
  },
  mounted: function () {
    //取得問題集
    this.vLoadFaq();
    //右下角貓頭鷹動畫
    $(window).mousemove(function (evt) {
      var pagex = evt.pageX;
      var pagey = evt.pageY;

      //計算相對區域的位置
      // var x = pagex-$("#owl_ani").offset().left;
      // var y = pagey-$("#owl_ani").offset().top;

      //計算中心位置
      var owlplace = $('#owl').offset().left + $('#owl').width() / 2;
      var owltop = $('#owl').offset().top;

      //左方 / 右方 / 上方
      if (pagex < owlplace - 50)
        $('#owl').attr('src', './img/faq/owl_left.svg');
      else if (pagex > owlplace + 50)
        $('#owl').attr('src', './img/faq/owl_right.svg');
      else $('#owl').attr('src', './img/faq/owl_top.svg');

      //左上 / 右上
      if (pagex < owlplace - 50 && pagey < owltop)
        $('#owl').attr('src', './img/faq/owl_left_top.svg');

      if (pagex > owlplace + 50 && pagey < owltop)
        $('#owl').attr('src', './img/faq/owl_right_top.svg');
    });
  },
  methods: {
    //網路連線狀態改變為 online 時觸發
    vNetworkOnline: function () {
      //取得問題集
      this.vLoadFaq();
    },
    //網路連線狀態改變為 offline 時觸發
    vNetworkOffline: function () {},
    vInitOriginFaq: function () {
      this.origin_faq = [
        {
          question_i18n: {
            'zh-TW': '我要去哪裡找寄物櫃？',
            'en-US': 'Where do I go to find the locker?',
          },
          answer_i18n: {
            'zh-TW': '請到智慧型寄物櫃官網的「空櫃/價格查詢」頁面查詢地點。',
            'en-US':
              'Please go to the "LOCKER STATUS / PRICE" page of the smart locker\'s official website to check the location.',
          },
          tag_i18n: [
            {
              'zh-TW': '詢問',
              'en-US': 'Ask',
            },
          ],
        },
        {
          question_i18n: {
            'zh-TW': '可以查詢寄物櫃的空箱狀態嗎？',
            'en-US': 'Can I check the empty box status of the locker?',
          },
          answer_i18n: {
            'zh-TW':
              '可以,請到智慧型寄物櫃官網的「空櫃/價格查詢」頁面查詢地點。',
            'en-US':
              'Yes, please go to the "LOCKER STATUS / PRICE" page of the smart locker\'s official website to check the location.',
          },
          tag_i18n: [
            {
              'zh-TW': '操作',
              'en-US': 'Operating',
            },
          ],
        },
      ];
    },
    //從cache / 網路載入問題集
    vLoadFaq: function () {
      var ref = this;
      if (!this.faq_api || this.faq_api.length <= 0) {
        ref.vRenderFaq(null);
        return;
      }
      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(this.faq_api).then((data) => {
        ref.vRenderFaq(data);
      });

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(this.faq_api).then((data) => {
        ref.vRenderFaq(data);
      });
    },
    //依資料重新渲染畫面
    vRenderFaq: function (faq_data) {
      if (faq_data && faq_data.length > 0) {
        this.origin_faq = faq_data;
      } else {
        this.vInitOriginFaq();
      }
      //整理 tag 分類資料
      this.vLoadTags();
      //預設顯示 "全部" 站點資料
      this.vFilterFaq(0);
    },
    //取得問題 tag 分類
    vLoadTags: function () {
      var i, j, i18n_key;
      //清除(但保留第1個element -> 全部)
      for (i = this.tags.length - 1; i > 0; i--) {
        this.tags.pop();
      }
      //建立 tag 分類
      for (i = 0; i < this.origin_faq.length; i++) {
        for (j = 0; j < this.origin_faq[i]['tag_i18n'].length; j++) {
          var tag_category = {};
          for (i18n_key in this.origin_faq[i]['tag_i18n'][j]) {
            tag_category[i18n_key] =
              this.origin_faq[i]['tag_i18n'][j][i18n_key];
          }
          tag_category['is_current'] = false;
          //沒有重複的元素才新增進去
          var repeat_tags = $.map(this.tags, function (item, index) {
            // console.log(index);
            return item['zh-TW'];
          }).indexOf(this.origin_faq[i]['tag_i18n'][j]['zh-TW']);
          if (repeat_tags < 0) {
            this.tags.push(tag_category);
          }
        }
      }
    },
    //過濾特定的 tag 問題內容
    vFilterFaq: function (tags_idx) {
      var ref = this;
      this.filter_faq = this.origin_faq.filter(function (item) {
        for (var i = 0; i < item['tag_i18n'].length; i++) {
          if (
            tags_idx === 0 ||
            item['tag_i18n'][i]['zh-TW'] === ref.tags[tags_idx]['zh-TW']
          ) {
            return true;
          }
        }
        return false;
      });
      //設定被指定的 tag 分類樣式
      for (var i = 0; i < this.tags.length; i++) {
        this.tags[i]['is_current'] = false;
      }
      this.tags[tags_idx]['is_current'] = true;
      //Gtag Event
      this.$gtag.event('問題標籤', {
        event_category: '常見問題',
        event_label: ref.tags[tags_idx]['zh-TW'],
        value: 1,
      });
    },
    //顯示黑板內容
    vShowFullFaqContent: function (faq_data) {
      this.current_q = faq_data['question_i18n'];
      this.current_a = faq_data['answer_i18n'];
      //Gtag Event
      this.$gtag.event('黑板內容', {
        event_category: '常見問題',
        event_label: faq_data['question_i18n']['zh-TW'],
        value: 1,
      });
    },
    //顯示提問視窗
    vShowSendQuestionWin: function () {
      this.show_question_win = true;
      //視窗開啟時自動滑到最上面
      $('html , body').animate({ scrollTop: 0 }, 500);
    },
    //關閉提問視窗
    vCloseSendQuestionWin: function () {
      if (!this.is_lock_send) {
        this.show_question_win = false;
        this.question_asker = '';
        this.question_content = '';
        this.question_error_label = 'fq_no_content';
        this.question_error = false;
        this.question_stress_textarea = false;
        this.replySuccess = false;
      } else {
        return false;
      }
    },
    //提問視窗 - 顯示傳送失敗
    vShowSendQuestionFail: function () {
      var ref = this;
      this.question_error_label = 'fq_send_fail';
      this.question_error = true;
      //若回應失敗，1秒後才可再次嘗試傳送
      setTimeout(function () {
        ref.is_lock_send = false;
        ref.replySuccess = false;
      }, 1000);
    },
    //傳送問題
    vSendQuestion: function () {
      const ref = this;
      //鎖住傳送鈕，避免重複點擊運算
      if (this.is_lock_send) {
        return;
      } else {
        this.is_lock_send = true;
        //每次進行傳送檢查前，先取消錯誤提示
        this.question_error = false;
        this.question_stress_textarea = false;
      }
      //未輸入提問者 email
      if (this.question_asker.length <= 0) {
        this.question_error_label = 'fq_no_email';
        this.question_error = true;
        this.is_lock_send = false;
        return;

        //檢查提問者 email 格式
      } else if (!Public.pbValidEmail(this.question_asker)) {
        this.question_error_label = 'fq_err_email';
        this.question_error = true;
        this.is_lock_send = false;
        return;
      }
      //未輸入提問內容
      if (this.question_content.length <= 0) {
        this.question_error_label = 'fq_no_content';
        this.question_error = true;
        this.question_stress_textarea = true;
        this.is_lock_send = false;
        return;
      }
      if (!this.send_faq_api || this.send_faq_api.length <= 0) {
        this.vShowSendQuestionFail();
        return;
      }

      // google reCAPTCHA v3 取回 token
      grecaptcha.ready(function () {
        grecaptcha
          .execute(ref.site_key, { action: 'homepage' })
          .then(function (token) {
            // console.log("v3 token => " + token);
            ref.vSendQuestionRequest(token);
          });
      });
    },
    vSendQuestionRequest: function (recaptcha_token = '') {
      var ref = this;
      fetch(this.send_faq_api, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: ref.question_asker,
          content: ref.question_content,
          recaptcha: recaptcha_token,
        }),
      })
        .then((res) => res.json())
        .then((json) => {
          // console.log(json);
          // 確保用戶能正確看到回饋，因此設定固定秒數來顯示動畫
          if (json['received']) {
            setTimeout(function () {
              // 切換成傳送成功視窗
              ref.replySuccess = true;
              setTimeout(function () {
                // 進入關閉視窗的處理 function
                ref.is_lock_send = false;
                ref.vCloseSendQuestionWin();
              }, 2000);
            }, 2000);
          } else {
            // 成功接收資料但內容不符
            setTimeout(function () {
              console.log('2');
              // 執行錯誤顯示 function
              ref.vShowSendQuestionFail();
            }, 2000);
          }
        })
        .catch((err) => {
          // console.log(err);
          // 任何傳輸中的網路錯誤狀況由這邊處理
          setTimeout(function () {
            ref.vShowSendQuestionFail();
          }, 2000);
        });
    },
  },
  watch: {
    net_offline: function (new_val) {
      if (new_val) {
        this.vNetworkOffline();
      } else {
        this.vNetworkOnline();
      }
    },
  },
};
</script>
v
